import React from 'react';
import { SIGNATURE, IMAGES } from '../data/mock';
import Reveal from './Reveal';

const SignatureDevice = () => {
  return (
    <section className="relative py-24 md:py-40 px-6 md:px-10">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-16 md:gap-20 items-center">
        <div className="order-2 md:order-1">
          <Reveal>
            <p className="text-[10px] tracking-[0.5em] text-[#c8935a] font-fell-sc">
              THE SIGNATURE DEVICE
            </p>
          </Reveal>
          <Reveal delay={100}>
            <h2 className="mt-6 font-display text-5xl md:text-6xl text-[#e8dcc0] lowercase leading-[1.05]">
              {SIGNATURE.lead}
            </h2>
          </Reveal>
          <Reveal delay={200}>
            <div className="mt-8 divider-ornament max-w-[220px] mx-0">
              <span className="text-[9px] tracking-[0.4em] font-fell-sc">ASH ROADS</span>
            </div>
          </Reveal>

          <Reveal delay={300}>
            <p className="mt-8 font-fell text-lg md:text-xl text-[#d9c8a3] leading-[1.85]">
              {SIGNATURE.body}
            </p>
          </Reveal>

          <Reveal delay={400}>
            <div className="mt-10 pl-6 border-l-2 border-[#c8935a]/60">
              <p className="font-fell italic text-2xl md:text-3xl text-[#f4e8ce] leading-snug">
                {SIGNATURE.close}
              </p>
            </div>
          </Reveal>
        </div>

        <Reveal delay={150} className="order-1 md:order-2">
          <div className="relative aspect-[5/4] overflow-hidden group">
            <div
              role="img"
              aria-label="Miniature Bamberg village on the interrogation table — the signature scenic device of ASH, the most immersive Halloween theatre show in London 2026."
              className="absolute inset-0 bg-cover bg-center transition-transform duration-[3000ms] group-hover:scale-105"
              style={{ backgroundImage: `url(${IMAGES.village})` }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0a0705]/60 via-transparent to-transparent" />
            {/* Candle glow accent */}
            <div
              className="absolute -inset-8 opacity-70 pointer-events-none flicker"
              style={{
                background:
                  'radial-gradient(circle at 88% 72%, rgba(220, 150, 70, 0.35) 0%, transparent 40%)'
              }}
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default SignatureDevice;
